import type { Status, StatusUpdate, Workflow, WorkflowUpdate } from './types';

export const mapStatusesToStatusUpdateObjects = (statuses: Status[]): StatusUpdate[] =>
	statuses.map((s) => ({
		id: s.id,
		name: s.name,
		description: s.description,
		statusReference: s.statusReference,
		statusCategory: s.statusCategory,
	}));

export const mapWorkflowToWorkflowUpdateObject = (workflow: Workflow): WorkflowUpdate => ({
	id: workflow.id,
	version: workflow.version,
	description: workflow.description,
	statuses: workflow.statuses.map(({ deprecated, ...status }) => status),
	transitions: workflow.transitions,
	startPointLayout: workflow.startPointLayout,
	statusMappings: workflow.statusMappings || [],
});
